export default __webpack_public_path__ + "static/media/team__item-img-4.7c059114.jpg";